// Logger utility — debug output is dev-only, errors/warnings always log.
// Usage: import { logger } from '../utils/logger';
//        logger.log('message');   logger.warn('message');   logger.error('message');

const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args) => {
    if (isDev) console.log(...args);
  },
  warn: (...args) => {
    console.warn(...args);
  },
  error: (...args) => {
    console.error(...args);
  },
};
